import { useState } from "react";
import { useAuth } from "@/lib/auth";
import { Lock, Mail, Loader2 } from "lucide-react";
import { useLocation } from "react-router-dom";
import voxyraSbcLogo from "@/assets/voxyra-sbc-logo.png";

const BG = "https://images.unsplash.com/photo-1691435828932-911a7801adfb?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjd8MHwxfHNlYXJjaHwxfHxkYXJrJTIwc2VydmVyJTIwcm9vbSUyMGZpYmVyJTIwb3B0aWN8ZW58MHx8fHwxNzgzNDY3MjQ0fDA&ixlib=rb-4.1.0&q=85";

export default function Login() {
  const { login, error } = useAuth();
  const location = useLocation();
  const agentAccess = location.pathname.startsWith("/agente");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    await login(email, password);
    setLoading(false);
  };

  return (
    <div className="min-h-screen relative flex items-center justify-start" data-testid="login-page">
      <div className="absolute inset-0" style={{
        backgroundImage: `url(${BG})`, backgroundSize: "cover", backgroundPosition: "center",
      }} />
      <div className="absolute inset-0" style={{ background: "linear-gradient(90deg, rgba(246,247,249,0.98) 0%, rgba(246,247,249,0.92) 40%, rgba(246,247,249,0.55) 100%)" }} />

      <div className="relative z-10 w-full max-w-md ml-4 sm:ml-10 lg:ml-16 p-6 sm:p-10 fade-in">
        <div className="mb-10">
          <div className="w-full max-w-[22rem] border border-[color:var(--border-strong)] rounded-sm bg-[color:var(--bg-surface)] p-3">
            <img src={voxyraSbcLogo} alt="Voxyra SBC" className="w-full h-auto object-contain" />
          </div>
          <div className="mt-3">
            <div className="text-xs uppercase tracking-[0.25em] text-[color:var(--text-muted)]">{agentAccess ? "Call center" : "Session Border Controller"}</div>
            <div className="text-2xl font-semibold tracking-tight">VOXYRA SBC</div>
          </div>
        </div>

        <div className="mb-8">
          <div className="text-xs uppercase tracking-widest text-[color:var(--text-muted)] mb-1">Acesso restrito</div>
          <div className="text-lg text-[color:var(--text-secondary)]">
            {agentAccess ? "Acesso exclusivo para agentes" : "Entre com suas credenciais de administracao"}
          </div>
        </div>

        <form onSubmit={submit} className="space-y-4">
          <div>
            <label className="text-[10px] uppercase tracking-widest text-[color:var(--text-muted)] font-semibold block mb-2">
              Email
            </label>
            <div className="relative">
              <Mail size={14} className="absolute left-3 top-1/2 -translate-y-1/2 text-[color:var(--text-muted)]" />
              <input
                data-testid="login-email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="sbc-input pl-9 font-mono"
                placeholder="operador@empresa.com"
                required
              />
            </div>
          </div>

          <div>
            <label className="text-[10px] uppercase tracking-widest text-[color:var(--text-muted)] font-semibold block mb-2">
              Senha
            </label>
            <div className="relative">
              <Lock size={14} className="absolute left-3 top-1/2 -translate-y-1/2 text-[color:var(--text-muted)]" />
              <input
                data-testid="login-password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="sbc-input pl-9 font-mono"
                placeholder="••••••••"
                required
              />
            </div>
          </div>

          {error && (
            <div data-testid="login-error" className="text-xs text-[color:var(--accent-red)] font-mono border border-[rgba(239,68,68,0.3)] bg-[rgba(239,68,68,0.08)] px-3 py-2 rounded-sm">
              ! {error}
            </div>
          )}

          <button
            data-testid="login-submit"
            type="submit"
            disabled={loading}
            className="sbc-btn sbc-btn-primary w-full justify-center h-10 text-sm mt-2"
          >
            {loading ? <Loader2 size={14} className="animate-spin" /> : null}
            {loading ? "Autenticando..." : "Autenticar sessão"}
          </button>
        </form>

      </div>
    </div>
  );
}
